module.exports = __webpack_public_path__ + "img/07@2x.3c98e090.png";